import { Me } from "../api/userTyped/Me";
import { StoreBase } from "../cutil/StoreBase";
import { Lazyload } from "../cutil/Lazyload";
import { JsonUtil } from "../cutil/JsonUtil";
import { tryPromise } from "../cutil/LangUtil";
export class MeStore extends StoreBase {
    constructor(brainClient) {
        super(() => new Me());
        this.brainClient = brainClient;
        this.lazyload = new Lazyload(() => {
            if (this.state.id !== undefined) {
                /// 已从fot收到数据，无需自己调api
                return Promise.resolve(this.state);
            }
            return this.brainClient.user.me().then(x => {
                const state = x.data ?? new Me();
                this.emit(state);
                return state;
            });
        });
        /**
         * 只需要记录一组数据就行了，避免内存占用过大
         * @private
         */
        this.profileImgUrlCache = {};
    }
    /**
     * 通过Profile_url 动态获取blob url
     */
    async profileImgUrl() {
        const result = await tryPromise(this.get());
        const imgUrl = result.data?.profile?.profile_img_url;
        if (result.data && imgUrl) {
            const cacheBlob = this.profileImgUrlCache[imgUrl];
            if (cacheBlob) {
                return cacheBlob.get();
            }
            const lazyLoad = new Lazyload(async () => {
                const resultNew = await tryPromise(this.get());
                const imgUrl = resultNew.data?.profile?.profile_img_url;
                if (imgUrl) {
                    const requesturl = `/api/me/upload/im?url=${imgUrl}`;
                    const url = this.brainClient.user.getBlobUrl(requesturl);
                    return url;
                }
                return "";
            });
            this.profileImgUrlCache = {};
            this.profileImgUrlCache[imgUrl] = lazyLoad;
            return lazyLoad.get();
        }
        return "";
    }
    async get() {
        return this.lazyload.get();
    }
    receive(meData) {
        if (meData == undefined) {
            return;
        }
        const me = JsonUtil.toModelFromType(Me, meData);
        if (me === undefined || me.id === undefined) {
            return;
        }
        this.lazyload.dirty();
        this.emit(me);
    }
    /// stock节点，用是否能进行操作
    async hasStockOperationPermission() {
        const me = await this.get();
        const permissions = me.profile?.permissions || [];
        const components = permissions
            .filter(per => {
            if (per.key === "components") {
                return true;
            }
            return false;
        })
            .first();
        if (components == undefined) {
            return false;
        }
        const hasPermission = components.value?.some(element => {
            return element === "brain_studios_stock_purchase";
        }) || false;
        return hasPermission;
    }
    async hasAskBrainStreamingPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_ask_brain_streaming") === false;
    }
    async hasAskBrainSocketPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_ask_brain_socket") === false;
    }
    async hasMidjourneyV2Permission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_midjourney_v2") === false;
    }
    async hasFunctionV2Permission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_backend_functions") === false;
    }
    async hasGlobalContextPermission() {
        const me = await this.get();
        if (me.is_guest) {
            return false;
        }
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_global_context") === false;
    }
    async hasGlobalContextGeneralPermission() {
        const me = await this.get();
        if (me.is_guest) {
            return false;
        }
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_global_context_general") === false;
    }
    async hasCustomIndexersPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_custom_indexers_response") === false;
    }
    async hasCotTemplateV2Permission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_cot_template_v2") === false;
    }
    async hasConsistentShareLinkPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_consistent_share_link") === false;
    }
    async hasPaywallPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_studios_paywall") === false;
    }
    /** 是否自动保存preview上setting、font等数据(BSF-6539) */
    async hasUpdatePreviewDataPermission() {
        const me = await this.get();
        const tags = me.feature_tags ?? [];
        return tags.includes("disable_update_preview_data") === false;
    }
}
